import { PureComponent } from 'react';

import './BlogFeed.style';

class BlogFeed extends PureComponent {
    renderPostTitle = title => ({ __html: title });

    renderPosts() {
        const { posts } = this.props;

        return (
            <div block="BlogList">
                { posts.map(post => (
                    <a key={ post.id } href={ post.link } block="BlogList" elem="Item" mix={ { block: 'BlogPost' } } target="_blank">
                        <div block="BlogPost" elem="ImageWrapper">
                            <div block="BlogPost" elem="Image" style={ { backgroundImage: `url(${post.magento_blog_image})` } } />
                        </div>
                        <div block="BlogPost" elem="Category">{ post.category_name }</div>
                        <div block="BlogPost" elem="Title" dangerouslySetInnerHTML={ this.renderPostTitle(post.title.rendered) } />
                    </a>
                )) }
            </div>
        );
    }

    render() {
        const { isLoading, code, posts } = this.props;

        if (code !== 'default' || isLoading || !Array.isArray(posts) || posts.length === 0) {
            return null;
        }

        if (isLoading) return null;

        return (
            <div block="BlogFeed" mix={ { block: 'Section' } }>
                <div block="Section" elem="Title"><span>{ __('The newest articles') }</span></div>
                <div block="Section" elem="Container">
                    <div block="BlogList" elem="Scroll">
                        { this.renderPosts() }
                    </div>
                    <div block="Section" elem="Footer">
                        <a href="/compania/articole-utile/" target="_blank" block="Button">DESCOPERĂ BLOGUL</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default BlogFeed;
